module.exports = __webpack_public_path__ + "img/wx.8c633c64.png";